// extracted by mini-css-extract-plugin
export default {"refreshStyle":"UnitStatsTable_refreshStyle__qCs5C","spinRefresh":"UnitStatsTable_spinRefresh__AMUUr","refreshStyleLoading":"UnitStatsTable_refreshStyleLoading__7fd7P"};